exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input{width:100%;height:31px;display:block;border:1px solid #cad2dd;background:#fff;margin-top:5px;color:#747474;font-weight:300;font-size:13px;border-radius:5px;text-align:start;overflow:visible!important;padding-left:7px;outline:0}.input::-webkit-input-placeholder{color:#a4b3c7;font-style:italic}.settings-wrapper{border:1px solid #cad2dd;border-radius:5px}.settings-wrapper .input{border:none;width:70%;display:inline-block;margin-top:0}.settings-wrapper .points-label{display:inline-block;text-align:center;background-color:#f4f6f7;width:30%;line-height:35px;color:#666;border-radius:5px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded!./client/components/SettingsModal/WidgetSettings/WidgetSettings.scss
 ** module id = 762
 ** module chunks = 0
 **/